import { render, staticRenderFns } from "./SavedSearchBalloon.vue?vue&type=template&id=523d4efb&scoped=true"
import script from "./SavedSearchBalloon.vue?vue&type=script&lang=ts"
export * from "./SavedSearchBalloon.vue?vue&type=script&lang=ts"
import style0 from "./SavedSearchBalloon.vue?vue&type=style&index=0&id=523d4efb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d4efb",
  null
  
)

export default component.exports